import {
  dashboard,
  userList,
  userMergeSuggestions,
  benefits,
  gym,
  gymTeacherDashboard,
  schools,
  attendanceReport,
  findPhysicalSpaces,
  tickets,
  workouts,
  finances,
  calendar,
  associationTitles,
  healthInsuranceComparisonReport,
  lifeInsuranceComparisonReport,
  biometryEnroll,
  physicalSpaceReservations,
  physicalAccess,
  customReport,
  contracts,
  campaigns,
  spaceRenting,
  events,
  accountsPayablePage,
  accountsReceivablePage,
  contractsCrm,
  cancellationReport,
  tasksBoard,
  notificationAnalytics,
  analyticsDashboard,
  aiUsageDashboard,
  mcpUsageDashboard,
  benefitPointsDashboard,
  nutritionDiary,
  convenioCredencial,
  convenioUsageList,
  convenioManagement,
  convenioInsights,
} from 'app/views/routes'
import { surveyBuilderNavigation } from 'app/navigation/surveyBuilderNavigation'
import { USER_TYPE } from 'app/ducks/auth/types'
import { TENANT_FLAG } from 'app/tenantFeatureFlags'
import { isRetentionModuleEnabled } from 'app/views/retention/hooks'
import { Store } from 'app/redux/Store'
import { getFeatureFlag } from 'app/ducks/featureFlags/selectors'
import { BENEFIT_POINTS_DASHBOARD_FLAG } from 'app/views/benefit-points/benefitPoints'
import { MCP_FLAG } from 'app/views/mcp/mcp'

// The menu entry for `benefitPointsDashboard`: unlike the route, hidden while
// the flags are still loading, so it never flashes in for a tenant without it
const benefitPointsDashboardNav = {
  ...benefitPointsDashboard,
  userCondition: () =>
    getFeatureFlag(Store.getState(), BENEFIT_POINTS_DASHBOARD_FLAG),
}

// Same for `mcpUsageDashboard`, whose route doesn't check the flag at all (the
// backend answers 404 when it's off, see app/views/mcp/mcp.js)
const mcpUsageDashboardNav = {
  ...mcpUsageDashboard,
  userCondition: () => getFeatureFlag(Store.getState(), MCP_FLAG),
}

// The lateral navigation used to be a flat/grouped list of ~20 routes
// (still readable in the previous shape of `navigations.js` — the
// legacy `Sidenav`/`MatxVerticalNav` components are kept around but are
// no longer wired into `Layout1`). `sections` groups those exact same
// route definitions — same roles/feature-flag/capability gating — into the 8
// major areas rendered by `SectionRail` (the icon rail) and the
// contextual top bar (`Layout1Topbar`), which turns each section's
// visible children into tabs.
//
// A section is visible when `shouldRenderNavigation` passes for it —
// which, absent its own `roles`/`featureFlag`, means "at least one
// child is visible". `contratos` and `administracao` keep the explicit
// role/feature-flag restriction their groups have in the old `navigations.js`.
export const sections = [
  {
    // No section-level gating needed: `dashboard` (see routes.js) carries
    // its own `userCondition`, reading `theme.hideDashboard` (set per
    // tenant in themeOptions.js), and a section with no visible children
    // hides itself.
    id: 'dashboard',
    name: 'Dashboard',
    icon: 'dashboard',
    children: [dashboard],
  },
  {
    id: 'pessoas',
    name: 'Pessoas',
    icon: 'people',
    children: [userList, associationTitles, userMergeSuggestions],
  },
  {
    id: 'financeiro',
    name: 'Financeiro',
    icon: 'attach_money',
    children: [
      finances,
      accountsPayablePage,
      accountsReceivablePage,
      healthInsuranceComparisonReport,
      lifeInsuranceComparisonReport,
      tickets,
    ],
  },
  {
    id: 'academia',
    name: 'Academia & Treinos',
    icon: 'sports_handball',
    children: [
      { ...workouts, name: 'Treinos', roles: [USER_TYPE.TOTEM] },
      gym,
      gymTeacherDashboard,
      nutritionDiary,
      surveyBuilderNavigation,
      schools,
      attendanceReport,
      biometryEnroll,
    ],
  },
  {
    id: 'contratos',
    name: 'Contratos',
    icon: 'article',
    roles: [USER_TYPE.ADMINISTRATOR],
    featureFlag: TENANT_FLAG.CONTRACTS_CRM,
    children: [
      contracts,
      contractsCrm,
      { ...cancellationReport, userCondition: isRetentionModuleEnabled },
    ],
  },
  {
    id: 'espacos',
    name: 'Espaços',
    icon: 'deck',
    children: [spaceRenting, findPhysicalSpaces, physicalSpaceReservations],
  },
  {
    id: 'engajamento',
    name: 'Engajamento',
    icon: 'campaign',
    children: [
      campaigns,
      events,
      calendar,
      benefits,
      convenioCredencial,
      convenioUsageList,
      convenioManagement,
      convenioInsights,
    ],
  },
  {
    id: 'administracao',
    name: 'Administração',
    icon: 'admin_panel_settings',
    roles: [USER_TYPE.ADMINISTRATOR],
    featureFlag: TENANT_FLAG.ADMINISTRATION_NAVIGATION,
    children: [
      {
        name: 'Administração',
        path: `${process.env.REACT_APP_BACKEND_URL}/admin`,
        type: 'extLink',
        icon: 'admin_panel_settings',
        roles: [USER_TYPE.ADMINISTRATOR],
        featureFlag: TENANT_FLAG.DJANGO_ADMIN_LINK,
      },
      tasksBoard,
      physicalAccess,
      customReport,
      analyticsDashboard,
      aiUsageDashboard,
      mcpUsageDashboardNav,
      benefitPointsDashboardNav,
      notificationAnalytics,
    ],
  },
]
